'use client';

import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

interface ExpandableItemsBlockProps {
  label: string;
  items?: Array<{ id?: string; name?: string }>;
}

const ExpandableItemsBlock = ({ label, items }: ExpandableItemsBlockProps) => {
  const [expanded, setExpanded] = useState(false);

  const safeItems = items?.filter((item) => item?.name?.trim()) ?? [];
  const hasItems = safeItems.length > 0;
  const collapsedCount = 2;
  const shouldCollapse = safeItems.length > collapsedCount;
  const visibleItems =
    expanded || !shouldCollapse
      ? safeItems
      : safeItems.slice(0, collapsedCount);

  return (
    <div
      style={{
        borderBottom: '1px solid var(--color-primary)',
        padding: '12px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        minWidth: 0,
      }}
    >
      <span
        style={{
          fontSize: 10,
          fontWeight: 800,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
        }}
      >
        {label}
      </span>

      {!hasItems ? (
        <div style={{ fontSize: 14, fontWeight: 500, lineHeight: 1.6 }}>—</div>
      ) : (
        <>
          <ul
            style={{
              margin: 0,
              paddingLeft: 18,
              display: 'flex',
              flexDirection: 'column',
              gap: 6,
              listStyle: 'disc',
            }}
          >
            {visibleItems.map((item, index) => (
              <li
                key={item.id || `${item.name}-${index}`}
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: 1.6,
                  wordBreak: 'break-word',
                }}
              >
                {item.name}
              </li>
            ))}
          </ul>

          {shouldCollapse && (
            <button
              type="button"
              onClick={() => setExpanded((prev) => !prev)}
              style={{
                width: 'fit-content',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                background: 'transparent',
                border: '1px solid var(--color-primary)',
                padding: '6px 10px',
                cursor: 'pointer',
                fontSize: 12,
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              {expanded ? (
                <>
                  <FiChevronUp size={14} />
                  Show Less
                </>
              ) : (
                <>
                  <FiChevronDown size={14} />
                  Show More
                </>
              )}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ExpandableItemsBlock;
